import cn from 'classnames';
import React, { FC } from 'react';
import { isMobile } from 'react-device-detect';
import { useTranslation } from 'react-i18next';
import './styles.scss';

type IProps = {
  classname?: string;
  data: any;
};

const SafeUserHistoryTable: FC<IProps> = ({ classname, data }) => {
  const { t }: Translation = useTranslation();

  return (
    <div className={cn('safe_user_history_table_wrapper', classname)}>
      {data?.length && data?.length > 0 ? (
        <>
          {isMobile ? (
            <div className="safe_user_history_table_mobile">
              {data.map((item: any) => (
                <div key={item.id} className="safe_user_history_table_card">
                  <div className="safe_user_history_table_card_img">
                    <img src={`/images/safePromo/${item.safeKey}.png`} alt={data?.name} className="safe_image" />
                  </div>
                  <div className="safe_user_history_table_card_info">
                    <div className="safe_user_history_table_card_info_row">
                      <span className="safe_user_history_table_card_info_title">{item.name}</span>
                      <div className={cn('safe_user_history_table_card_info_status', item.status)}>
                        <span>{item.status}</span>
                      </div>
                    </div>
                    <div className="safe_user_history_table_card_info_row">
                      <div className="safe_user_history_table_card_info_block">
                        <span className="safe_user_history_table_card_info_block_name">{t('date')}:</span>
                        <span className="safe_user_history_table_card_info_block_value">{item.date}</span>
                      </div>
                      <div className="safe_user_history_table_card_info_block">
                        <span className="safe_user_history_table_card_info_block_name">{t('code')}:</span>
                        <span className="safe_user_history_table_card_info_block_value">{item.code}</span>
                      </div>
                    </div>
                    <div className="safe_user_history_table_card_info_row">
                      <div className="safe_user_history_table_card_info_block">
                        <span className="safe_user_history_table_card_info_block_name">{t('time')}:</span>
                        <span className="safe_user_history_table_card_info_block_value">{item.time}</span>
                      </div>
                      {item.prize && (
                        <div className="safe_user_history_table_card_info_block">
                          <span className="safe_user_history_table_card_info_block_name">{t('prize')}:</span>
                          <span className="safe_user_history_table_card_info_block_value">{item.prize}</span>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <table className="safe_user_history_table">
              <thead className="safe_user_history_table_head">
                <tr className="safe_user_history_table_row">
                  <th className="safe_user_history_table_col">{t('name')}</th>
                  <th className="safe_user_history_table_col">{t('date')}</th>
                  <th className="safe_user_history_table_col">{t('time')}</th>
                  <th className="safe_user_history_table_col">{t('code')}</th>
                  <th className="safe_user_history_table_col">{t('status')}</th>
                  <th className="safe_user_history_table_col">{t('prize')}</th>
                </tr>
              </thead>
              <tbody className="safe_user_history_table_body">
                {data.map((item: any) => (
                  <tr key={item.id} className="safe_user_history_table_row">
                    <td className="safe_user_history_table_col">
                      <img src={`/images/safePromo/${item.safeKey}.png`} alt={data?.name} className="safe_image" />
                      <span>{item.name}</span>
                    </td>
                    <td className="safe_user_history_table_col">{item.date}</td>
                    <td className="safe_user_history_table_col">{item.time}</td>
                    <td className="safe_user_history_table_col">{item.code}</td>
                    <td className="safe_user_history_table_col">
                      <span className={cn('safe_user_history_table_status', item.status)}>{item.status}</span>
                    </td>
                    <td className="safe_user_history_table_col">{item.prize}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </>
      ) : (
        <div className="safe_user_history_table_empty">
          <span>{t('noHistoryYet')}</span>
        </div>
      )}
    </div>
  );
};

export default SafeUserHistoryTable;
